module.exports = __webpack_public_path__ + "img/technical_support_03.32fed45d.jpg";